import React, { memo } from 'react';

import { log } from '../../services/utils';

import { useAuthState } from '../../contexts/AuthContext';

import NavItem from '../Shared/NavItem';

import styles from './sidebar.module.css';
import PermissionsWrapper from '../PermissionsWrapper';

const OperationsSidebar = () => {
	const { user: { permissions } } = useAuthState();

	return (
		<div className={ styles.sidebarMenuContainer }>
			{ log( 'operationsSidebar' ) }
			<PermissionsWrapper permission={ permissions.listContacts.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="address card"
					title="Contacts"
					to="/operations/contacts"
				/>
			</PermissionsWrapper>
			<PermissionsWrapper permission={ permissions.listPrograms.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="clipboard list"
					title="Programs"
					to="/operations/programs"
				/>
			</PermissionsWrapper>
			{/* <NavItem
				className={ styles.sidebarLink }
				icon="money bill alternate outline"
				title="Funding"
				to="/operations/funding"
			/> */}
			<PermissionsWrapper permission={ permissions.listCalendarEvents.isAvailable }>
				<NavItem
					className={ styles.sidebarLink }
					icon="calendar alternate"
					title="Calendar"
					to="/operations/calendar"
				/>
			</PermissionsWrapper>
		</div>
	);
};

export default memo( OperationsSidebar );
